import React, { Component } from 'react';
import _ from 'underscore';
import {
  Table,
  Segment,
  Form,
  Dropdown,
  Button,
  Checkbox,
  Loader
} from "semantic-ui-react";
import "./ResultPlot.css";
import Errorpop from "../error/Errorpop";
import moment from 'moment';

var ES6Promise = require("es6-promise");
ES6Promise.polyfill();
var axios = require('axios');

export default class ResultPlot extends Component {
  constructor(props) {
    super(props);
    this.state = {
      maxMonth: moment().format('YYYYMM'),
      allLoc: [],
      locPicks: [],
      resultData: [],
      lineOption: [],
      zoneOption: [],
      LocOption: [],
      reportMode: this.props.initialReportMode === "trend" ? "trend" : "detail",
      selLine: "All Lines",
      selZone: "All Zones",
      selLoc: "All Locations",
      trendZone: "All Zones",
      showPosOnly: false,
      loading: true
    };
    this.errorpop = React.createRef();
  }

  getMonths = (resultData) => {
    return _.uniq(_.pluck(resultData, "mon_of_sample")).filter((value) => value);
  }

  getTrendMonths = () => {
    var months = [];
    var endMonth = this.state.maxMonth ? moment(this.state.maxMonth, "YYYYMM") : moment();
    var cursor = moment().subtract(1, "year").startOf("year");

    if (cursor.isAfter(endMonth)) {
      cursor = moment(endMonth).startOf("year");
    }
    while (cursor.isSameOrBefore(endMonth, "month")) {
      months.push(cursor.format("YYYYMM"));
      cursor = cursor.add(1, "months");
    }
    return months;
  }

  normalizeZone = (zone) => {
    return zone === undefined || zone === null ? "" : String(zone).trim();
  }

  getZoneOptions = (zones) => {
    var normalized = _.uniq(_.map(zones || [], (zone) => this.normalizeZone(zone)));
    normalized = _.filter(normalized, (zone) => zone !== "");
    normalized = _.sortBy(normalized, (zone) => String(zone).toLowerCase());
    return [{ "text": "All Zones", "value": "All Zones" }].concat(
      normalized.map((zone) => ({ "text": zone, "value": zone }))
    );
  }

  toNumber = (value) => {
    var n = parseInt(value, 10);
    return Number.isNaN(n) ? 0 : n;
  }

  getResults = () => {
    if (!this.props.custid) return;
    this.setState({ loading: true });
    axios.get("/api/getResultForRpt?cust_id=" + this.props.custid)
      .then((result) => {
        const payload = Array.isArray(result.data) ? result.data : [];
        if (result.status === 200) {
          const months = this.getMonths(payload);
          const maxMonth = months.length > 0
            ? _.max(months, function (value) { return value; })
            : moment().format('YYYYMM');
          console.log(payload);
          this.setState({
            maxMonth: maxMonth,
            resultData: payload,
            loading: false
          });
        }
        else {
          console.log("error" + JSON.stringify(result));
          this.setState({ loading: false });
          if (this.errorpop.current) this.errorpop.current.handleOpen();
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading: false });
      });
  }

  getLocations = () => {
    if (!this.props.custid) return;
    axios.get("/api/getLoc?custid=" + this.props.custid)
      .then((result) => {
        const payload = Array.isArray(result.data) ? result.data : [];
        if (result.status === 200) {
          var lineList = [{ "text": "All Lines", "value": "All Lines" }];
          _.uniq(_.pluck(payload, 'line_nm')).forEach((item) => lineList.push({ "text": item, "value": item }));
          var zoneList = this.getZoneOptions(_.pluck(payload, 'zone_nm'));
          var locList = [{ "text": "All Locations", "value": "All Locations" }];
          _.uniq(_.pluck(payload, 'loc_nm')).forEach((item) => locList.push({ "text": item, "value": item }));

          this.setState({
            allLoc: _.sortBy(payload, function (data) { return data.line_nm + ' ' + data.zone_nm + ' ' + data.loc_nm }),
            lineOption: _.sortBy(lineList, 'text'),
            zoneOption: zoneList,
            LocOption: _.sortBy(locList, 'text'),
            locPicks: _.sortBy(payload, function (data) { return data.line_nm + ' ' + data.zone_nm + ' ' + data.loc_nm })
          });
        }
        else {
          console.log("error" + JSON.stringify(result));
          if (this.errorpop.current) this.errorpop.current.handleOpen();
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  changeLine = (event, data) => {
    var zoneList = this.getZoneOptions(
      data.value === "All Lines"
        ? _.pluck(this.state.allLoc, 'zone_nm')
        : _.pluck(_.where(this.state.allLoc, { "line_nm": data.value }), 'zone_nm')
    );

    var locList = [{ "text": "All Locations", "value": "All Locations" }];
    if (data.value === "All Lines")
      _.uniq(_.pluck(this.state.allLoc, 'loc_nm')).forEach((item) => locList.push({ "text": item, "value": item }));
    else
      _.uniq(_.pluck(_.where(this.state.allLoc, { "line_nm": data.value }), 'loc_nm').filter((item) => item))
        .forEach((item) => locList.push({ "text": item, "value": item }));

    var locPicks = (data.value === "All Lines")
      ? this.state.allLoc
      : _.where(this.state.allLoc, { "line_nm": data.value });

    this.setState({
      zoneOption: zoneList,
      locPicks: locPicks,
      LocOption: _.sortBy(locList, 'text'),
      selLine: data.value,
      selZone: "All Zones",
      selLoc: "All Locations"
    });
  }

  changeZone = (event, data) => {
    var locPicks = [];
    var locList = [{ "text": "All Locations", "value": "All Locations" }];
    if (this.state.selLine === "All Lines")
      if (data.value === "All Zones") {
        locPicks = this.state.allLoc;
        _.uniq(_.pluck(this.state.allLoc, 'loc_nm')).forEach((item) => locList.push({ "text": item, "value": item }));
      }
      else {
        _.uniq(_.pluck(_.where(this.state.allLoc, { "zone_nm": data.value }), 'loc_nm').filter((item) => item))
          .forEach((item) => locList.push({ "text": item, "value": item }));
        locPicks = _.where(this.state.allLoc, { zone_nm: data.value });
      }
    else
      if (data.value === "All Zones") {
        _.uniq(_.pluck(_.where(this.state.allLoc, { "line_nm": this.state.selLine }), 'loc_nm').filter((item) => item))
          .forEach((item) => locList.push({ "text": item, "value": item }));
        locPicks = _.where(this.state.allLoc, { line_nm: this.state.selLine });
      }
      else {
        _.uniq(_.pluck(_.where(this.state.allLoc, { "line_nm": this.state.selLine, "zone_nm": data.value }), 'loc_nm').filter((item) => item))
          .forEach((item) => locList.push({ "text": item, "value": item }));
        locPicks = _.where(this.state.allLoc, { line_nm: this.state.selLine, zone_nm: data.value });
      }

    this.setState({
      locPicks: locPicks,
      LocOption: _.sortBy(locList, 'text'),
      selZone: data.value,
      selLoc: "All Locations"
    });
  }

  changeLoc = (event, data) => {
    var locPicks = [];
    if (this.state.selLine === 'All Lines') locPicks = this.state.allLoc;
    else locPicks = _.where(this.state.allLoc, { line_nm: this.state.selLine });
    if (this.state.selZone !== 'All Zones') locPicks = _.where(locPicks, { zone_nm: this.state.selZone });
    if (data.value !== "All Locations") {
      locPicks = _.where(locPicks, { loc_nm: data.value });
    }
    this.setState({ selLoc: data.value, locPicks: locPicks });
  }

  togglePos = () => {
    this.setState({ showPosOnly: !this.state.showPosOnly });
  }

  resetOptions = () => {
    var lineList = [{ "text": "All Lines", "value": "All Lines" }];
    _.uniq(_.pluck(this.state.allLoc, 'line_nm')).forEach((item) => lineList.push({ "text": item, "value": item }));
    var zoneList = this.getZoneOptions(_.pluck(this.state.allLoc, 'zone_nm'));
    var locList = [{ "text": "All Locations", "value": "All Locations" }];
    _.uniq(_.pluck(this.state.allLoc, 'loc_nm')).forEach((item) => locList.push({ "text": item, "value": item }));
    this.setState({
      lineOption: _.sortBy(lineList, 'text'),
      zoneOption: zoneList,
      LocOption: _.sortBy(locList, 'text'),
      locPicks: _.sortBy(this.state.allLoc, function (data) { return data.line_nm + ' ' + data.zone_nm + ' ' + data.loc_nm }),
      selLine: "All Lines",
      selZone: "All Zones",
      selLoc: "All Locations",
      trendZone: "All Zones",
      showPosOnly: false
    });
  }

  changeTrendZone = (event, data) => {
    this.setState({ trendZone: data.value });
  }

  getTrendData = () => {
    var months = this.getTrendMonths();
    var trendData = [];
    var totals = {};
    months.forEach((month) => {
      totals[month] = { mon_of_sample: month, sum_pos: 0, sum_neg: 0 };
    });

    this.state.resultData.forEach((item) => {
      if (months.indexOf(item.mon_of_sample) === -1) return;
      if (this.state.trendZone !== "All Zones" && item.zone_nm !== this.state.trendZone) return;
      totals[item.mon_of_sample].sum_pos += this.toNumber(item.sum_pos);
      totals[item.mon_of_sample].sum_neg += this.toNumber(item.sum_neg);
    });

    months.forEach((month) => {
      trendData.push(totals[month]);
    });
    return trendData;
  }

  getTrendLinePoints = (values, width, height, leftPad, rightPad, topPad, bottomPad, maxValue) => {
    var step = values.length > 1 ? (width - leftPad - rightPad) / (values.length - 1) : 0;
    return values.map((data, index) => {
      var x = leftPad + step * index;
      var y = topPad + (height - topPad - bottomPad) - ((maxValue === 0 ? 0 : data / maxValue) * (height - topPad - bottomPad));
      return x + "," + y;
    }).join(" ");
  }

  renderTrendChart = () => {
    if (this.state.loading) {
      return (
        <div className="trend-chart-wrap trend-loading">
          <Loader active inline="centered" size="large" />
          <div style={{ marginTop: "0.5em", color: "#666" }}>Loading trend data...</div>
        </div>
      );
    }

    var trendData = this.getTrendData();
    var trendMonths = this.getTrendMonths();
    var rangeLabel = trendMonths.length > 0
      ? `${moment(trendMonths[0], "YYYYMM").format("MMM YYYY")} - ${moment(trendMonths[trendMonths.length - 1], "YYYYMM").format("MMM YYYY")}`
      : "";
    var monthLabels = [];
    var posValues = [];
    var negValues = [];

    trendData.forEach((data) => {
      monthLabels.push(moment(data.mon_of_sample, "YYYYMM").format("MMM YYYY"));
      posValues.push(this.toNumber(data.sum_pos));
      negValues.push(this.toNumber(data.sum_neg));
    });

    var maxValue = 1;
    for (var i = 0; i < posValues.length; i++) {
      if (posValues[i] > maxValue) maxValue = posValues[i];
      if (negValues[i] > maxValue) maxValue = negValues[i];
    }
    maxValue = maxValue > 0 ? maxValue : 1;

    var width = 900;
    var height = 380;
    var leftPad = 50;
    var rightPad = 20;
    var topPad = 20;
    var bottomPad = 45;
    var chartWidth = width - leftPad - rightPad;
    var chartHeight = height - topPad - bottomPad;
    var yBase = topPad + chartHeight;
    var posLine = this.getTrendLinePoints(posValues, width, height, leftPad, rightPad, topPad, bottomPad, maxValue);
    var negLine = this.getTrendLinePoints(negValues, width, height, leftPad, rightPad, topPad, bottomPad, maxValue);

    var gridLines = [];
    var xStep = trendData.length > 1 ? chartWidth / (trendData.length - 1) : 0;
    var yStep = chartHeight / 4;
    for (var g = 0; g <= 4; g++) {
      var gy = topPad + g * yStep;
      var labelValue = Math.round(maxValue - (maxValue / 4) * g);
      gridLines.push(
        <g key={"grid" + g}>
          <line x1={leftPad} y1={gy} x2={leftPad + chartWidth} y2={gy} stroke="#e0e1e2" strokeWidth="1" />
          <text x={leftPad - 10} y={gy + 4} textAnchor="end" fill="#666" fontSize="10">{labelValue}</text>
        </g>
      );
    }

    var xLabels = monthLabels.map((monthLabel, index) => (
      <text
        key={"month" + index}
        x={leftPad + (index * xStep)}
        y={height - 10}
        textAnchor="middle"
        fill="#666"
        fontSize="11"
      >{monthLabel}</text>
    ));

    return (
      <div className="trend-chart-wrap">
        <div className="trend-chart-meta">
          <span style={{ marginRight: "1.5em", color: "#cc3f44", fontWeight: 600 }}>Positive</span>
          <span style={{ color: "#2185d0", fontWeight: 600 }}>Negative</span>
          <span style={{ marginLeft: "1.5em", color: "#666" }}>{rangeLabel}</span>
        </div>
        <svg className='trend-chart' viewBox={`0 0 ${width} ${height}`}>
          <rect x="0" y="0" width={width} height={height} fill="#fff" />
          <line x1={leftPad} y1={yBase} x2={leftPad + chartWidth} y2={yBase} stroke="#666" strokeWidth="1" />
          <line x1={leftPad} y1={topPad} x2={leftPad} y2={topPad + chartHeight} stroke="#666" strokeWidth="1" />
          {gridLines}
          {xLabels}
          <polyline fill="none" stroke="#cc3f44" strokeWidth="2.5" points={posLine} />
          <polyline fill="none" stroke="#2185d0" strokeWidth="2.5" points={negLine} />
          {trendData.map((item, index) => {
            var x = leftPad + xStep * index;
            var posY = topPad + chartHeight - ((posValues[index] / maxValue) * chartHeight);
            var negY = topPad + chartHeight - ((negValues[index] / maxValue) * chartHeight);
            return [
              <circle key={"p" + index} cx={x} cy={posY} r="3" fill="#cc3f44" />,
              <circle key={"n" + index} cx={x} cy={negY} r="3" fill="#2185d0" />
            ];
          })}
        </svg>
      </div>
    );
  }

  componentDidMount() {
    this.getResults();
    this.getLocations();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.initialReportMode !== this.props.initialReportMode && this.props.initialReportMode) {
      this.setState({ reportMode: this.props.initialReportMode });
    }
  }

  render() {
    var trendMonths = this.getTrendMonths();
    var monthList = [];
    trendMonths.forEach((month, i) => {
      monthList.push(
        <Table.HeaderCell width={1} key={'month' + i}>
          {moment(month, "YYYYMM").format("MMM YYYY")}
        </Table.HeaderCell>
      );
    });

    var rowList = [];
    this.state.locPicks.forEach((data, index) => {
      var dataList = [];
        var totalpos = 0;
        var totalneg = 0;
        trendMonths.forEach((mon_to_search) => {
          var countrow = _.where(this.state.resultData, { loc_nm: data.loc_nm, mon_of_sample: mon_to_search })[0];
          dataList.push(
            <Table.Cell key={'datarow-' + index + '-' + mon_to_search}>
              <div className={countrow && countrow.sum_pos > 0 ? 'postext' : ''}>{countrow ? '+' + countrow.sum_pos : ''}</div>
              <div className='negtext'>{countrow ? '-' + countrow.sum_neg : ''}</div>
            </Table.Cell>
          );
          totalpos += countrow ? this.toNumber(countrow.sum_pos) : 0;
          totalneg += countrow ? this.toNumber(countrow.sum_neg) : 0;
        });
        var summaryCell =
          <Table.Cell>
            <div className={totalpos > 0 ? 'postext' : ''}>+{totalpos}</div>
          <div className='negtext'>-{totalneg}</div>
        </Table.Cell>;
      if (this.state.showPosOnly === false || totalpos > 0)
        rowList.push(
          <Table.Row key={'datarow' + index}>
            <Table.Cell>{data.line_nm}</Table.Cell>
            <Table.Cell>{data.zone_nm}</Table.Cell>
            <Table.Cell>{data.loc_nm}</Table.Cell>
            <Table.Cell>{data.loc_desc}</Table.Cell>
            {dataList}
            {summaryCell}
          </Table.Row>
        );
    });

    var tableBody = this.state.loading ? (
      <Table.Row>
        <Table.Cell colSpan={8}>Loading trend data...</Table.Cell>
      </Table.Row>
    ) : rowList.length > 0 ? rowList : (
      <Table.Row>
        <Table.Cell colSpan={8}>No trend data available for this customer yet.</Table.Cell>
      </Table.Row>
    );

    var detailTable =
      <Table celled size='small'>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width={1}>Line</Table.HeaderCell>
            <Table.HeaderCell width={1}>Zone</Table.HeaderCell>
            <Table.HeaderCell width={1}>Location</Table.HeaderCell>
            <Table.HeaderCell width={2}>Description</Table.HeaderCell>
            {monthList}
            <Table.HeaderCell width={1}>Total</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {tableBody}
        </Table.Body>
      </Table>;

    var content = this.state.reportMode === 'trend'
      ? this.renderTrendChart()
      : detailTable;
    var trendZoneOptions = this.getZoneOptions(_.pluck(this.state.allLoc, 'zone_nm'));

    return (
      <Segment className='mainseg'>
        <div className='report-dashboard-toolbar'>
          <label>Report Dashboard ({this.state.reportMode === "trend" ? "Trend" : "Detail"})</label>
        </div>
        <Form>
          <Form.Group stackable>
            {this.state.reportMode === 'detail' &&
              <Form.Field width={4}>
                <label>Line</label>
                <Dropdown fluid selection options={this.state.lineOption}
                  value={this.state.selLine} onChange={this.changeLine} />
              </Form.Field>
            }
            {this.state.reportMode === 'detail' &&
              <Form.Field width={4}>
                <label>Zone</label>
                <Dropdown fluid selection options={this.state.zoneOption}
                  value={this.state.selZone} onChange={this.changeZone} />
              </Form.Field>
            }
            {this.state.reportMode === 'detail' &&
              <Form.Field width={4}>
                <label>Location</label>
                <Dropdown fluid selection options={this.state.LocOption}
                  value={this.state.selLoc} onChange={this.changeLoc} />
              </Form.Field>
            }
            {this.state.reportMode === 'trend' &&
              <Form.Field width={4}>
                <label>Zone</label>
                <Dropdown fluid selection options={trendZoneOptions}
                  value={this.state.trendZone} onChange={this.changeTrendZone} />
              </Form.Field>
            }
            {this.state.reportMode === 'detail' &&
            <Form.Field width={4}>
                <label>Show Positive Only</label>
                <Checkbox toggle checked={this.state.showPosOnly} onChange={this.togglePos} />
            </Form.Field>
            }
            <Button primary onClick={this.resetOptions} >Reset</Button>
          </Form.Group>
        </Form>
        {content}
        <Errorpop ref={this.errorpop} />
      </Segment>
    );
  }
}
